import React, { useEffect, useState } from 'react';
import FormTemplate, { THEMES } from '@/components/formTemplate';
import Delivery from '@/containers/chooseDelivery/delivery';
import { DELIVERY, DELIVERY_MAPPED_OPTIONS } from '@/constants/operation';

function ChooseDelivery({
  control,
  title,
  step = null,
  showForm = true,
  deliveryMethods,
  shippingText = null,
  simSelected = true,
  esimText = null,
  portabilityText,
  defaultDeliveryMethod,
  simDeliveryTexts,
}) {
  const [deliveryMethodsState, setDeliveryMethods] = useState(null);
  const mapDeliveryMethods = () => {
    const values = [...deliveryMethods.SIM];
    return values.map((item) => ({
      label: { text: DELIVERY_MAPPED_OPTIONS[item] || item },
      value: item,
    }));
  };

  useEffect(() => {
    if (deliveryMethods) {
      setDeliveryMethods(mapDeliveryMethods());
    }
  }, [deliveryMethods]);

  return (
    <div className="choose-operation-container">
      {deliveryMethodsState && showForm && (
        <FormTemplate
          step={step}
          theme={showForm ? THEMES.FULL : THEMES.LONG}
          withHorizontalSeparator={false}
        >
          <Delivery
            id={DELIVERY.ID}
            deliveryMethods={deliveryMethodsState}
            title={title}
            shippingText={shippingText}
            simSelected={simSelected}
            esimText={esimText}
            defaultDeliveryMethod={defaultDeliveryMethod}
            simDeliveryText={
              portabilityText
                ? `${simDeliveryTexts}<br>${portabilityText}`
                : simDeliveryTexts
            }
            {...{ control }}
          />
        </FormTemplate>
      )}

      <style jsx>
        {`
          .choose-operation-container {
            margin-bottom: 12px;
            :global(.choose-operation-desc) {
              margin: 0px 0px 8px 0px;
            }
          }
        `}
      </style>
    </div>
  );
}
export default ChooseDelivery;
